import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import CheveronRightIcon from '../Icons/CheveronRight';

import { container, containerCategoryStyle, arrow } from './styles.module.css';

const Arrow = () => (
  <span className={arrow}>
    <CheveronRightIcon />
  </span>
);

const Crumb = (props) => {
  const {
    linkInfo: { label, permalink },
    withArrow,
    onClick,
  } = props;
  return (
    <span onClick={onClick}>
      {permalink ? <Link to={permalink}>{label}</Link> : <span>{label}</span>}
      {withArrow && <Arrow />}
    </span>
  );
};

const Breadcrumbs = (props) => {
  const { links, useCategoryStyle, onClick } = props;
  const containerClass = useCategoryStyle ? containerCategoryStyle : container;
  return (
    <div className={containerClass}>
      {links &&
        links.map((linkInfo, index) => (
          <Crumb
            key={linkInfo.label}
            linkInfo={linkInfo}
            withArrow={index + 1 < links.length}
            onClick={() =>
              onClick({
                label: linkInfo.label,
                permalink: linkInfo.permalink,
                index,
              })
            }
          />
        ))}
    </div>
  );
};

Breadcrumbs.propTypes = {
  useCategoryStyle: PropTypes.bool,
};

Breadcrumbs.defaultProps = {
  useCategoryStyle: false,
};

export default Breadcrumbs;
